module.exports = __webpack_public_path__ + "static/img/Group 2.b256311.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Group 2.png
// module id = UVAm
// module chunks = 1